import React from 'react';

export default class DashboardIcon extends React.Component {
  render() {
    return (
      <svg height="100%" viewBox="0 0 18.714 16.422">
        <path
          fill="#BD311F"
          d="M18.617,9.131L9.65,0.058c-0.076-0.077-0.213-0.077-0.289,0L0.364,9.162C0.306,9.22,0.035,9.307,0.067,9.383
          C0.098,9.459,0,9.53,0,9.53V9.422h3v6.797v0.203H2.998H7V9.915V9.422h5v7h3.402h0.203c0.112,0,0.394-0.091,0.394-0.203V9.422h2.502
          c0.003,0,0.005,0,0.008,0c0.112,0,0.203-0.048,0.203-0.16C18.714,9.188,18.675,9.167,18.617,9.131z"
        />
        <g id="BS8q3m.tif">
          <image
            overflow="visible"
            width="17"
            height="17"
            id="Layer_0_1_"
            transform="matrix(1 0 0 1 104 -0.2892)"
          />
        </g>
        <rect x="71" y="2.422" fill="#BD311F" width="17" height="14" />
        <path
          fill="#BD311F"
          d="M75,4.672c0,0.414-0.336,0.75-0.75,0.75h-0.5c-0.414,0-0.75-0.336-0.75-0.75v-3.5
          c0-0.414,0.336-0.75,0.75-0.75h0.5c0.414,0,0.75,0.336,0.75,0.75V4.672z"
        />
        <path
          fill="#BD311F"
          d="M80,3.672c0,0.414-0.336,0.75-0.75,0.75h-0.5c-0.414,0-0.75-0.336-0.75-0.75v-3.5
          c0-0.414,0.336-0.75,0.75-0.75h0.5c0.414,0,0.75,0.336,0.75,0.75V3.672z"
        />
        <g />
        <g />
        <g />
        <g />
        <g />
        <g />
        <g />
        <g />
        <g />
        <g />
        <g />
        <g />
        <g />
        <g />
        <g />
      </svg>
    );
  }
}



// WEBPACK FOOTER //
// ./js/components/icons/DashboardIcon.js